const cards = [
  {
    title: '千万粉美妆博主直播翻车，粉丝集体脱粉',
    excerpt: '某平台头部美妆博主在最新直播中因不当言论引发众怒，三小时内掉粉超百万。网友扒出其过往黑料，事件持续发酵……',
    tag: '网红塌房',
    heat: '1,286万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20coral%20red%20abstract%20editorial%20composition%20with%20soft%20gradient%20glow%2C%20modern%20news%20card%20aesthetic%2C%20dramatic%20lighting%2C%20dark%20and%20warm%20tones%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20visual%20for%20entertainment%20content%20platform&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '娱乐圈知名导演被曝潜规则多名女艺人',
    excerpt: '匿名知情人士向51吃瓜黑料爆料，某资深导演在选角过程中存在严重不当行为。多位圈内人士已出面作证，事件或涉及更多知名人物……',
    tag: '明星爆料',
    heat: '2,058万',
    img: 'https://readdy.ai/api/search-image?query=Deep%20amber%20and%20burgundy%20abstract%20backdrop%20with%20soft%20light%20beam%2C%20mysterious%20cinematic%20atmosphere%2C%20modern%20editorial%20style%2C%20rich%20warm%20gradients%2C%20no%20text%2C%20no%20people%2C%20dramatic%20and%20sophisticated&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '健身博主人设是假的？前女友放实锤',
    excerpt: '拥有三百万粉丝的健身博主被前女友曝光私下完全不是自律人设，不仅有严重不良嗜好，还存在PUA行为。女方放出大量聊天记录与照片作为证据……',
    tag: '博主反差',
    heat: '987万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20dark%20coral%20abstract%20geometric%20composition%2C%20layered%20translucent%20shapes%2C%20modern%20editorial%20news%20visual%2C%20soft%20atmospheric%20glow%2C%20rich%20contrast%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20entertainment%20platform%20style&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '网红情侣分手互撕，双方各自放出黑料',
    excerpt: '曾被誉为模范情侣的两位网红近日官宣分手，随后在社交平台展开隔空互撕。双方粉丝站队混战，吃瓜群众直呼比电视剧还精彩……',
    tag: '网曝门',
    heat: '1,542万',
    img: 'https://readdy.ai/api/search-image?query=Rich%20warm%20gold%20and%20deep%20red%20abstract%20composition%2C%20dramatic%20dual%20tone%20lighting%2C%20modern%20magazine%20cover%20aesthetic%2C%20bold%20editorial%20style%2C%20no%20text%2C%20no%20people%2C%20striking%20visual%20for%20entertainment%20news&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '某选秀冠军被曝学历造假，人设全面崩塌',
    excerpt: '51吃瓜黑料接到知情人爆料，某选秀冠军的学历存在严重造假问题。经多方核实，其声称的名校学历未在任何官方记录中找到对应信息……',
    tag: '黑料合集',
    heat: '1,876万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20coral%20and%20warm%20amber%20abstract%20background%20with%20dramatic%20shadow%20contrast%2C%20spotlight%20effect%2C%20modern%20editorial%20photography%20style%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20visually%20striking&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '短视频平台顶流突然停更，背后真相惊人',
    excerpt: '坐拥千万粉丝的短视频达人突然宣布无限期停更，引发全网猜测。51吃瓜黑料独家追踪发现，停更原因可能与近期一系列负面事件密切相关……',
    tag: '吃瓜一线',
    heat: '3,215万',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20gradient%20abstract%20composition%20with%20coral%20and%20gold%20highlights%2C%20soft%20dreamy%20atmosphere%2C%20modern%20cinematic%20aesthetic%2C%20editorial%20breaking%20news%20style%2C%20no%20text%2C%20no%20people%2C%20rich%20depth%20and%20warm%20tonality&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export default function InfoCards() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
              热门爆料
            </h2>
          </div>
          <a
            href="#"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/60 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                  <i className="ri-fire-line text-accent-400 text-xs"></i>
                  {card.heat}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}